import type { ReactNode } from 'react';
import { SystemPackageVersionAboutSection } from '../system-package-version-about-section/SystemPackageVersionAboutSection.ctrl';
import { SystemPackageVersionDefinitionSection } from '../system-package-version-definition-section/SystemPackageVersionDefinitionSection.ctrl';
import type { SystemPackageVersionDefinitionStepProps } from './systemPackageVersionDefinitionStep.model';
import styles from './systemPackageVersionDefinitionStep.module.scss';

export function SystemPackageVersionDefinitionStep({
  control,
  hiddenFields,
  operationalSystemDependencyOptions,
  minimumOSVersionOptions,
  systemPackageDependencyOptions,
  minimumSystemPackageVersionOptions,
  appDependencyOptions,
  minimumAppVersionOptions,
  fieldsLoading,
}: SystemPackageVersionDefinitionStepProps): ReactNode {
  return (
    <div className={styles.container}>
      <SystemPackageVersionDefinitionSection control={control} />
      <SystemPackageVersionAboutSection
        appDependencyOptions={appDependencyOptions}
        control={control}
        fieldsLoading={fieldsLoading}
        hiddenFields={hiddenFields}
        minimumAppVersionOptions={minimumAppVersionOptions}
        minimumOSVersionOptions={minimumOSVersionOptions}
        minimumSystemPackageVersionOptions={minimumSystemPackageVersionOptions}
        operationalSystemDependencyOptions={operationalSystemDependencyOptions}
        systemPackageDependencyOptions={systemPackageDependencyOptions}
      />
    </div>
  );
}
